import { Markdown } from './Markdown';
import { SourcesList, type Source } from './SourcesList';
import { Meta } from './Meta';
import { Notice, type NoticeData } from './Notice';

export interface MessageBodyData {
  status?: string;
  content?: string;
  sources?: Source[];
  meta?: { threadKey?: string; turn?: number; verbosity?: string; durationSeconds?: number };
  notice?: NoticeData;
}

export function MessageBody({ content, sources, meta, notice }: MessageBodyData) {
  const isComplete = !!meta;
  return (
    <div>
      {content && <Markdown content={content} />}
      {isComplete && sources && sources.length > 0 && <SourcesList sources={sources.slice(0, 5)} />}
      {meta && <Meta {...meta} />}
      {notice && <Notice {...notice} />}
    </div>
  );
}
